module.exports = __webpack_public_path__ + "d15d5e74c1e9a2c70ab87c7a67225846.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boat-shoes-blue-s.png
// module id = 1871
// module chunks = 0